/*
	This file holds misc utils that don't really belong to any other collections of functionality.
*/
import sleep from 'sleep-promise';  //todo replace w simple sleep


const _throttledLogTable = {};  //used by throttleAllow and throttledConsoleLog
const _throttleLedgers = {};    //used by allowMulti

let abortCount = 0; //number of network calls that were aborted

export const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const DAYS_OF_WEEK_ABBREV = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];


// import {Clipboard, Platform} from 'react-native';

//width=device-width, initial-scale=1, user-scalable=no
let isMobileVal;
export function isMobile(actualValue) {
  if (isMobileVal === undefined) {
    isMobileVal = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf('Mobi') >= 0;

    // let w = window.screen.width;
    // let h = window.screen.height;
    // let m = navigator.userAgent.indexOf("Mobi") >= 0;
    // alert(`w:${w} h:${h} m:${m} r:${isMobileVal}`);

    console.log('isMobile: ' + isMobileVal);

    // isMobileVal = false;
  }
  return actualValue ? isMobileVal : false; //mostly hardwiring to NOT mobile to prevent tiny text while we sort out configs fleetwide
}

export function isWideMobile() {
  if (!isMobile()) return false;
  var elem = document.getElementById('root');
  return elem.clientWidth >= elem.clientHeight;
}

export function isTall() {
  var elem = document.getElementById('root');
  return elem.clientWidth < elem.clientHeight;
}

export function isTallMobile() {
  if (!isMobile()) return false;
  var elem = document.getElementById('root');
  return elem.clientWidth < elem.clientHeight;
}

/*
 * Creates a unique id.
 *
 * @param {int} numRandomHexDigits - how many random hex digits should be appended to the
 *    result.
 * @return {string} a unique id consisting of the current time in hex, then a dash, then as
 *    many random hex digits as were specified.
 */
function makeId(numRandomHexDigits=4) {
  return Date.now().toString(16) + '-' + randomHex(numRandomHexDigits);
}


export function randomHex(numRandomHexDigits) {
  let randHex = Math.floor(16 ** numRandomHexDigits * Math.random()).toString(16);
  while (randHex.length < numRandomHexDigits) randHex = '0' + randHex;
  return randHex;
}

/**
 * Return a string representation of a number, padded to two digits with zero if otherwise
 * shorter.
 *
 * @param {int} an integer.
 * @return {string} string representation of x; if < 2 in length, prepended with a '0'.
 */
function p2(x) {
  let result = '' + x;
  if (result.length < 2) result = '0' + result;
  return result;
}


/*
 * This routine gives client code a way to express that only a certain number of things
 * should happen within a span of time starting a certain number of minutes in the past
 * (relative to the present).
 *
 * Example intended usage: if we want to log no more than 3 log messages every 5 minutes, the
 * code would look like this:
 *
 *      if(allowMulti('myArbitraryLogString', 3, 5)
 *          console.log('here is my message');
 *
 *
 * @param {string} type - an id/key allowing a given client code usage to differentiate from
 *    other instances of use.
 * @param {int} maxAllowed - the maximum number of times this routine should return true in
 *    the time window.
 * @param {int} inMinutesWindow - the number of most recent minutes in which to count events.
 * @return {boolean} true IFF the call should be allowed (i.e. IFF the number of calls to this
 *    routine in the time window is less than maxAllowed.
 */
export function allowMulti(type, maxAllowed, inMinutesWindow) {
  if (maxAllowed <= 0) return true;

  const nowTicks = Date.now();
  let ledger = (_throttleLedgers[type] = _throttleLedgers[type] || []);

  //ledger is just an array of tick values when the operation was allowed.
  // Discard entries old enough that they no longer matter to us
  while (ledger.length && nowTicks - ledger[0] >= inMinutesWindow * 60 * 1000) {
    ledger.shift();
  }

  if (ledger.length < maxAllowed) {
    ledger.push(nowTicks);
    return true; //allow (whatever); we haven't yet reached/exceeded our maxAllowed
  }

  return false; //client should disallow the gated operation
}

/*
 * Copies the provided string to the clipboard.
 *
 * @param stringToCopy - the string to copy to the clipboard.
 */
function copyToClipboard(stringToCopy) {
  // if(Platform.OS == 'web') {
  const el = document.createElement('textarea');
  el.value = stringToCopy;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  // }
  // else {
  // Clipboard.setString(stringToCopy)
  // }
}

/*
 * Compares two things and returns true if they hold the same content.
 */
function areSame(a, b) {
  if (a === b) return true;

  if (!a || !b) return false;

  if (typeof a != typeof b) return false;
  let type = typeof a; //a and b are the same type

  if (type == 'number' || type == 'boolean' || type == 'string') return false; //our triple compare above would have returned true

  if (type == 'object') {
    if (a.constructor !== b.constructor) {
      return false;
    }
    const customAreSame = a.constructor.areSame;
    if (customAreSame instanceof Function) {
      return customAreSame(a, b);
    }
    if (Array.isArray(a) != Array.isArray(b)) return false;
    if (Array.isArray(a)) {
      //they're both arrays
      if (a.length != b.length) return false;
      for (let i = 0; i < a.length; ++i) {
        if (!areSame(a[i], b[i])) return false;
      }
      return true;
    }
    else {
      //they're both objects
      let aKeys = Object.keys(a);
      let bKeys = Object.keys(b);
      aKeys.sort();
      bKeys.sort();
      if (!areSame(aKeys, bKeys)) return false;
      for (let i = 0; i < aKeys.length; ++i) {
        if (!areSame(a[aKeys[i]], b[bKeys[i]])) return false;
      }
      return true;
    }
  }
  throw new Error('Unexpected type: ' + type);
}



function netErrStr(err) {
  if(!err) return '';

  let errStr = '' + err;

  if (errStr.indexOf('Failed to fetch') >= 0)
    errStr = 'Unreachable';
  else if(errStr.indexOf('AbortError') >= 0) 
    errStr = 'Timed out';
  else if(errStr.startsWith('Exception: '))
    errStr = 'An error occurred'

  return errStr;
}


/*
    On success, returns json || {}.

    handlers: optional; can consist of (1) success function, or (2) object with various combinations of the below handler:
        success: on success, called with json || {}
        bad: {err, netResult, logStr} called if exception or !.ok or .status!=200; err and netResult are mut exclusive; logStr is loggable string
        notOk: (netResult) called if !.ok or .status!=200
        caught: (err) called if exception
        - bad and (notOk||caught) are mutually exclusive.
        - If no error handling specified, errors are snuffed.
        final: (wasGood) called after other handlers.

    If handlers are specified, the outcome-specific ones will have been called by the time this function returns.
*/
export async function clearFetch(url, options, handlers, timeoutTicks) {
  let success, bad, notOk, caught, final, badJson;
  if (handlers) {
    if (typeof handlers == 'function') success = handlers;
    else {
      let allowed = 'success,bad,notOk,caught,final,badJson'.split(',');
      Object.keys(handlers).forEach((k) => {
        if (allowed.indexOf(k) < 0) throw new Error('clearFetch: unrecognized handler: ' + k);
      });
      success = handlers.success;
      bad = handlers.bad;
      notOk = handlers.notOk;
      caught = handlers.caught;
      final = handlers.final;
      badJson = handlers.badJson;

      if (bad && (notOk || caught)) throw new Error('clearFetch: bad params');
    }
  }

  options = options || {};

  let abortTimeout, aborted = false;
  if(!isNaN(timeoutTicks)) {

    //We're deliberately not using options.signal=AbortSignal.timeout(ticks) 
    // because ios doesn't appear to support it until 18.x.
    try {
      timeoutTicks = Math.max(0, Number(timeoutTicks || 0));
      let abortController = new AbortController();
      options.signal = abortController.signal;

      abortTimeout = setTimeout(() => {

        abortTimeout = undefined;
        abortController.abort();
        aborted = true;
        ++abortCount;

        if(allowMulti(`didNetAbort`, 1, 10)) {
          url = url.toString().endsWith('/moxiState') ? '/moxiState' : url;
          doElasticLogError({what:'netAbort', msg:`aborted at ${Math.round(timeoutTicks / 100)/10}s (total=${abortCount}) ` + url, url, timeoutTicks});
        }

      }, timeoutTicks);
    }
    catch(err) {
      delete options.signal;
      if(allowMulti(`timeoutSetup`, 1, 15))
        doElasticLogError({what:'netTOSetupErr', msg:`Error setting up network timeout: ` + err});
    }
  }


  let netResult;
  try {
    netResult = await fetch(url, options);
  }
  catch (err) {
    err = netErrStr(err);

    if (bad) bad({ err, logStr: '' + err });
    else if (caught) caught(err);

    if (final) final(false);

    return undefined;
  }
  finally {
    if(abortTimeout) {
      clearTimeout(abortTimeout);
    }
  }

  if (!netResult.ok || netResult.status != 200) {
    let errJson;
    try {
      errJson = await netResult.json();
    }
    catch(err) {
      console.log(`Error getting error-path json: ` + err);
    }

    if (bad) {
      let logStr;
      if(typeof(errJson?.error) == 'string') {
        logStr = netErrStr(errJson.error);
      }
      else {
        let netErrMsg = netErrStr(netResult.error || '');
        if(netErrMsg)
          netErrMsg = ' ' + netErrMsg;
        logStr = `${netResult.status} ok=${netResult.ok} ${netResult.statusText}${netErrMsg}`;
      }

      bad({ netResult, logStr, errJson});
    }
    else if (notOk) {
      notOk(netResult);
    }

    if (final) final(false);

    return undefined;
  }

  let json, text;
  try {
    json = (await netResult.json()) || {};
  }
  catch (err) {

    err = netErrStr(err);

    let text = '';
    try { text = await netResult.text()} catch(err) {/*snuff*/}
    if(text) { try{json = JSON.parse(text)} catch(err) {/*snuff*/}}

    if(text)
      doElasticLogError({what:'textFetch', msg:`Got text reply to ${url}`, url, text});

    const contentType = netResult.headers.get('content-type');
    const jsonExpected = contentType && contentType.indexOf('application/json');

    if(!json) {
      if(jsonExpected) {
        if (badJson) badJson('' + err);
        else if (bad) bad({ netResult, logStr: err });
        else if (notOk) notOk(netResult);

        if (final) 
          final(false);

        return undefined;
      }
      else {
        json = {};
      }
    }
  }

  if (success) {
    try {
      await success(json, text);
    }
    catch(err) {
      console.log(`clearFetch: error from success handler: ` + err);
    }
  }


  if (final) {
    final(true);
  }

  return json || {};
}

export function unsubscribe(dis, fieldName) {
  if (dis[fieldName]) {
    dis[fieldName]();
    dis[fieldName] = undefined;
  }
}


/*
	Dump msg (preceded by key) to log, but only IFF it has been at least strideSeconds
	since the previous key was used to do a log.
*/
export function throttledConsoleLog(key, msg, strideSeconds = 60 * 5) {
  if(throttleAllow(key, strideSeconds))
    console.log(`${key}: ${msg}`);
}


//returns true IFF hasn't returned true for key in strideSeconds
export function throttleAllow(key, strideSeconds = 60 * 5) {
  if (!key || typeof(key) != 'string') throw new Error(`throttleAllow: key must be a non-empty string, but saw type=${typeof(key)} truthy=${!!key}`);

  let entry = (_throttledLogTable[key] = _throttledLogTable[key] || { when: 0 });
  let now = Date.now();
  if (now - entry.when >= strideSeconds * 1000) {
    entry.when = now;
    return true;
  }
}


const shared = {};

export function getShared() {
  return shared;
}


export function noteInteraction() {
  shared.interaction = Date.now();
}

// Exact same impl as that used in the firestore sdk's toDate() method.
export function toDate(secsAndNanos) {
  return new Date(secsAndNanos.seconds * 1e3 + secsAndNanos.nanoseconds / 1e6);
}

export { makeId, copyToClipboard, areSame, p2 };

export function isIOS() {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}

export async function asyncSetState(thees, state) {
  await new Promise((resolve, reject) => thees.setState(state, resolve));
}

export function makeUnwinder() {
  let q = [];
  let result = {
    addFunc: (f) => q.push(f),
    addInterval: (intervalId) => q.push(() => clearInterval(intervalId)),
    addTimeout: (thees, label) => {
      q.push(() => {
        if (thees[label]) {
          clearTimeout(thees[label]);
          thees[label] = undefined;
        }
      });
    },
    unwind: () => {
      while (q.length) q.pop()();
    },
  };
  return result;
}

export function getHrsMinsAmpm(ticks) {
  let d = new Date(ticks);
  let [h, m, s] = [d.getHours(), d.getMinutes(), d.getSeconds()];
  let ampm = h >= 12 ? 'pm' : 'am';
  if (ampm == 'pm') h -= 12;
  if (!h) h = 12; //whether 12am or adding 12 back to 12pm

  return { h, m, s, ampm };
}


export function getHrsMinsAmpmStr(ticks, includeSeconds) {
  let { h, m, s, ampm } = getHrsMinsAmpm(ticks);
  let result = `${h}:${p2(m)}${ampm}`;
  if(includeSeconds) result += `+${s}s`;
  return result;
}


export function neuterEvt(e) {
  e.stopPropagation();
  e.preventDefault();
  e.cancelBubble = true;
  e.returnValue = false;
  return false;
}


function doElasticLogError(data) {
  let elasticLogError = getShared().elasticLogError;
  if(elasticLogError)
    elasticLogError(data);
  else
    console.log(`elasticLogError: ` + JSON.stringify(data, 0, 2));
}


export function decodeUrlParams(loadUrl) {
  let params = {};
  if(loadUrl) {
    const decodedUrl = decodeURI(loadUrl);
    let paramsIdx = decodedUrl.indexOf('?');
    if(paramsIdx >= 0) {
      decodedUrl.slice(paramsIdx + 1).split('&').forEach(p => {
        let [label, value] = p.split('=');
        params[label] = value;
      });
    }
  }
  return params;
}


export function setUrlParams(url, urlParamsDict={}) {
  let keys = Object.keys(urlParamsDict);
  if(!keys.length) return url;

  let decodedUrl = decodeURI(url);
  let paramsIdx = decodedUrl.indexOf('?');
  if(paramsIdx >= 0)
    decodedUrl = decodedUrl.slice(0, paramsIdx);

  let urlWithNewParams = `${decodedUrl}?${keys.map(k => `${k}=${urlParamsDict[k]}`).join('&')}`;

  return encodeURI(urlWithNewParams);
}


export function arrLast(arr) {
  if(arr?.length);
    return arr[arr.length - 1];
}


export function arrGet(arr, idx) {
  if(!arr) return;

  if(idx >= 0)
    return arr[idx];
  
  return arr[arr.length + idx];
}
